import styled from 'styled-components';
import { StyledCheckoutStepListProps } from './CheckoutStepList.types';

export const StyledCheckoutStepList = styled.section<StyledCheckoutStepListProps>`
  .checkout-step-list__step {
    display: flex;
    flex-direction: column;
  }

  ${(props) => props.customStyle}
`;
